import { StoreWritable, createStore, createEvent } from 'effector'
import { callWsService } from './call-ws.service'

export type AivyState = 'loading' | 'talking' | 'listen-user' | 'thinking'

class CallAivyStateService {
  readonly $aivyState: StoreWritable<AivyState> =
    createStore<AivyState>('loading')
  readonly setAivyState = createEvent<AivyState>()

  constructor() {
    this.$aivyState.on(this.setAivyState, (_, nSt) => nSt)
  }

  subscribe = (): VoidFunction => {
    const sub1 = callWsService.wsClosed.watch(() => {
      this.setAivyState('loading')
    })
    const sub2 = callWsService.wsOpened.watch(() => {
      this.setAivyState('loading')
    })
    const sub3 = callWsService.$store
      .map((x) => x.ws)
      .watch((ws) => {
        if (ws) return
        this.setAivyState('loading')
      })

    return (): void => {
      sub1.unsubscribe()
      sub2.unsubscribe()
      sub3.unsubscribe()
    }
  }
}

export const callAivyStateService = new CallAivyStateService()
